<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
// eslint-disable-next-line camelcase
import userActionsApi from '@/api/userActions.js'

export default {
  name: 'App',
  data () {
    return {
    }
  },
  methods: {
    resize () {
      let width = window.innerWidth
      // let height = window.innerHeight
      let app = document.getElementById('app')
      // console.log(width, height)
      app.style.transform = `scale(${width / (this.$isPhone ? 1080 : 1920)})`
    }
  },
  mounted () {
    // 用户访问信息
    userActionsApi.addUserAction({
      actionCode: 'access'
      // terminalType: this.$isPhone ? 'mobile' : 'pc'
    })
    this.$nextTick(() => {
      this.resize()
    })
    window.addEventListener('resize', () => {
      this.resize()
    })
  }
}
</script>

<style lang="less">
@import "~@/styles/variables.less";
     // 修改默认滚动条样式
   *::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

*:hover::-webkit-scrollbar-thumb {
  background: hsla(0, 0%, 53%, 0.4);
}

*:hover::-webkit-scrollbar-track {
  background: hsla(0, 0%, 53%, 0.1);
}
#app {
    width: 100%;
    height: 100%;
    transform-origin: 0 0;
    // -webkit-transform-style: preserve-3d;
  }
</style>
